import React from 'react'

export function ResultDisplay({ result }) {
  if (!result || !result.image) {
    return null
  }

  const downloadImage = () => {
    const link = document.createElement('a')
    link.href = `data:${result.image.mimeType};base64,${result.image.data}`
    link.download = `ai-generated-${Date.now()}.${result.image.mimeType.split('/')[1]}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className="result-section">
      <h3 style={{ 
        color: '#667eea', 
        marginBottom: '1rem', 
        fontSize: '1.5rem',
        fontWeight: '600'
      }}>
        🎨 Image générée
      </h3>
      
      <img
        src={`data:${result.image.mimeType};base64,${result.image.data}`}
        alt="Image générée par IA"
        className="result-image"
      />
      
      {result.caption && (
        <div className="result-caption">
          "{result.caption}"
        </div>
      )}
      
      <div style={{ 
        display: 'flex', 
        gap: '1rem', 
        justifyContent: 'center',
        marginTop: '1.5rem'
      }}>
        <button
          onClick={downloadImage}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '10px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)'
            e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)'
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)'
            e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)'
          }}
        >
          💾 Télécharger
        </button>
      </div>
    </div>
  )
}